<template>
  <div class="searchDetail">
<!--    <div>-->
<!--      <otherNav></otherNav>-->
<!--    </div>-->
    <h3>{{this.title}}</h3>
    <div class="date">发布时间：{{this.createTime}}</div>
    <div class="ql-container">
      <p class=" pre ql-snow ql-editor content-detail  content" v-html="this.content"></p>
    </div>

    <div class="fileList" v-if="this.dynamicFileList">
      <div class="file" >
        <div v-for="(file,fileIndex) in this.dynamicFileList" :key="fileIndex" style="display: flex">
          <el-link @click="previewFile(file)"><i class="el-icon-document"></i>附件：{{file.name}}<i class="el-icon-download el-icon--right"></i> </el-link>
        </div>
      </div>
    </div>
    <div class="fileList" v-if="this.workGuideFileList">
      <div class="file" >
        <div v-for="(file,fileIndex) in this.workGuideFileList" :key="fileIndex"
             style="display: flex">
          <div @click="previewFile(file)" style="min-width: 100%">
            <div style="font-weight: 700;padding-left: 0;width: 100%;color: darkred;font-size: 18px">附件：</div>
            <el-divider></el-divider>
            <div class="link">
              <i class="el-icon-connection"></i>
              <span style="font-size: 16px">{{file.name}}</span>
            </div>
          </div>
          <!--          <div @click="previewFile(file)"><i class="el-icon-document"></i>-->
          <!--            <div style="display: block; font-weight: 700">附件：</div>-->
          <!--            <div>-->
          <!--            {{file.name}}<i class="el-icon-download el-icon&#45;&#45;right"></i>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import otherNav from '@/components/navBar/otherNav'

export default {
  name: "searchDetail",
  components: {  otherNav },
  data() {
    return {
      content: '',
      createTime: '',
      title: '',
      dynamicFileList: [],
      dynamicPictureFileList: [],
      workGuideFileList: [],
      editorText: '',
      editorImg: [],

    }
  },
  beforeRouteLeave(to, from, next){
    if(to.path == '/searchPage') {
      to.meta.isUseCache = true
    }
    next()
  },
  mounted() {
    // console.log(this.$route.query)
    // this.detailId = this.$route.params.id
    this.formName = this.$route.query.formName
    this.content = this.$route.query.content
    this.createTime = this.$route.query.createTime
    this.title = this.$route.query.title
    this.dynamicFileList = this.$route.query.dynamicFileList
    this.dynamicPictureFileList = this.$route.query.dynamicPictureFileList
    this.workGuideFileList = this.$route.query.workGuideFileList
    this.getEditorText(this.content)
    this.fn(this.content)
    this.imgHandle(this.content)
  },
  methods: {

    previewFile(row) {
      // console.log(row)
      this.videoUrl = 'http://192.168.0.124:9999/admin/sys-file/' + row.bucketName + '/' + row.name
      let url = 'http://192.168.0.124:9999/admin/sys-file/' + row.bucketName + '/' + row.name
      window.open('http://192.168.0.124:8012/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)), '_blank')
    },
    imgHandle(val) {
      this.content = val.replace(/\<img/gi, '<img style="margin:0 auto;display:block;"')
      // console.log(this.detailList.content)
    },
    //截取除图片外的所有文字
    getEditorText(str){
      this.editorText = str.replace(/<\/?(img|table)[^>]*>/g, "")
      // console.log(this.editorText)
      // this.editorText = str.replace(/<[^>]+>/g, "")
      return this.editorText
    },
    //处理图片
    fn(str) {
      str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
        this.editorImg.push(capture)
      })
      return  this.editorImg
    },
    handleSelect(key, keyPath) {
      this.$router.push({path:key}).catch(err => { console.log(err) })
    },
  }
}
</script>

<style scoped lang="scss">
.searchDetail {
    //min-height: 1000px;
    //padding: 0 100px;
  //text-align: left;
  .nav {
    padding: 0;
    width: 100%;
    height: 60px;
    color: #fff !important;
    z-index: 999;
    margin: 0 auto !important;
    ::v-deep .el-menu {
      font-size: 18px !important;
      border-bottom: 0px;
    }
    ::v-deep .el-menu--horizontal>.el-menu-item {
      font-size: 18px !important;
    }
    ::v-deep .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
      color: #fff !important;
      font-size: 18px;
    }
    ::v-deep .el-menu-item.is-active {
      color: #fff;
      font-size: 18px;
      background-color: #003673 !important;
    }
    ::v-deep .el-submenu__title {
      font-size: 18px !important;
      color: white;
    }
    .el-menu.el-menu--horizontal {
      border-bottom: none;
    }
  }
  .nav, .nav-sm {
    .el-menu-item .is-active {
      opacity: 1 !important;
      color: #fff !important;
    }
    .el-submenu__title i {
      opacity: 1 !important;
      color: #ffff !important;
    }
  }
  .nav-sm {
    display: none;
  }

  h3 {
    padding: 20px;
  }
  .content {
    font-size: 16px;
    padding: 5px 100px;
    //text-align: left;
    line-height: 40px;
    text-indent: 2em;
    white-space: pre-wrap;
  }
  .date {
    padding: 10px 0;
    color: #999;
    font-size: 14px;
    //float: right;
    text-align: center;
  }
  .file {
    padding: 5px;
    text-align: center;
    .img {
      width: 150px;
      height: 30%;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    //}

  }
}
.editorImg{
  //width: 80%;
  //height: 500px;
  //padding: 10px 0;
  //margin: 0 auto;
  img {
    //width: 100%;
    //height: 100%;
    object-fit: contain;
    display: inline-block;
  }
}
@media screen and (max-width: 1200px){
  .searchDetail {
    min-height: 1000px;
  }
  .editorImg{
    img {
      object-fit: contain;
      display: inline-block;
    }
  }
  //.editorImg{
  //  width: 80%;
  //  height: 400px;
  //  padding: 10px 0;
  //  margin: 0 auto;
  //  img {
  //    width: 100%;
  //    height: 100%;
  //  }
  //}
}
@media screen and (max-width: 992px){
  .searchDetail {
    min-height: 1000px;
    //padding: 0 50px;
  }
  .content {
    padding: 5px 50px !important;
  }
  .editorImg {
    img {
      object-fit: contain;
      display: inline-block;
    }
  }
}
@media screen and (max-width: 768px){
  .searchDetail {
    min-height: 1000px;
    //padding: 0 20px;
  }
  .content {
    padding: 5px 20px !important;
  }
  .editorImg {
    img {
      object-fit: contain;
      display: inline-block;
    }
  }
}
@media screen and (max-width: 576px){
  .searchDetail {
    min-height: 500px;
  }
  .content {
    padding: 5px 10px !important;
  }
  .editorImg {
    img {
      object-fit: contain;
      display: inline-block;
    }
  }
}
</style>